import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { create } from 'zustand';
import { useUserOwnsPlaylist } from '../../savedItems';
import FormattedMessage from 'I18n/components/FormattedMessage';
import produce from 'immer';
import { persist } from 'zustand/middleware';
import UsageTracker from '../../../utils/UsageTracker';
import { SavePlaylistButton } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SAVE_PLAYLIST_TOOLTIP_LOCALSTORAGE_KEY = 'academy:savePlaylistTooltipState';
export const useSavePlaylistTooltipState = create()(persist(set => ({
  hasClosedSavePlaylistTooltip: false,
  setClosedTooltip: value => set(produce(state => {
    state.hasClosedSavePlaylistTooltip = value;
  }))
}), {
  name: SAVE_PLAYLIST_TOOLTIP_LOCALSTORAGE_KEY
}));
export const SavePlaylistTooltip = ({
  playlistId,
  children
}) => {
  const {
    hasClosedSavePlaylistTooltip,
    setClosedTooltip
  } = useSavePlaylistTooltipState();
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const handleActionClick = action => {
    UsageTracker.track('interaction', {
      action,
      playlistId
    });
    setClosedTooltip(true);
  };
  const showTooltip = userIsOwner === false && !hasClosedSavePlaylistTooltip;
  return /*#__PURE__*/_jsx(UITooltip, {
    open: showTooltip,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.tooltips.oneTimeSavePlaylist"
      }), /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-top-2",
        children: [/*#__PURE__*/_jsx(SavePlaylistButton, {
          onClick: () => handleActionClick('save-playlist-tooltip-save'),
          playlistId: playlistId,
          render: () => /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'learningCenter.common.save'
          }),
          style: {
            padding: '8px 24px'
          },
          use: "tertiary-light"
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: () => handleActionClick('save-playlist-tooltip-close'),
          style: {
            padding: '8px 24px'
          },
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.savedItems.tooltips.oneTimeSavePlaylistClose"
          })
        })]
      })]
    }),
    children: children
  });
};
export default SavePlaylistTooltip;